<div class="ibox">
    <div class="ibox-content">
        <table class="table">
            <thead>
                <tr>
                    <th class="col-thead">{{column}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let field of columnFields">
                    <td class="col-value">{{field}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
